(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clc-er-announcement-nav"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__clcErInit) return; window.__clcErInit = true;
  var root = document.documentElement;

  // ---- scroll-reveal (opt-in, motion-safe) ----
  var motionOK = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (motionOK && 'IntersectionObserver' in window){
    root.classList.add('clc-anim-ready');
    var rio = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    var scan = function(){ document.querySelectorAll('[data-clc-reveal]:not(.is-in)').forEach(function(el){ rio.observe(el); }); };
    scan(); document.addEventListener('shopify:section:load', scan);
  }

  // ---- header on scroll ----
  var header = document.querySelector('[data-clc-header]');
  var onScroll = function(){ if(!header) return; if(window.scrollY > 24) header.setAttribute('data-clc-scrolled',''); else header.removeAttribute('data-clc-scrolled'); };
  window.addEventListener('scroll', onScroll, { passive:true }); onScroll();

  // ---- mobile menu ----
  var burger = document.querySelector('[data-clc-burger]');
  var menu = document.querySelector('[data-clc-mobile-menu]');
  if (burger && menu){
    burger.addEventListener('click', function(){
      var open = menu.hasAttribute('hidden');
      if(open){ menu.removeAttribute('hidden'); burger.setAttribute('aria-expanded','true'); }
      else { menu.setAttribute('hidden',''); burger.setAttribute('aria-expanded','false'); }
    });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ menu.setAttribute('hidden',''); burger.setAttribute('aria-expanded','false'); }); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clc-er-quiz"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__clcErQuiz) return; window.__clcErQuiz = true;

  /* ---------- sticky bar hide near footer / offer / final ---------- */
  var sticky = document.querySelector('[data-clc-sticky]');
  if (sticky && 'IntersectionObserver' in window){
    var visible = new Set();
    var io = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting) visible.add(e.target); else visible.delete(e.target); });
      if(visible.size > 0) sticky.setAttribute('data-clc-hidden',''); else sticky.removeAttribute('data-clc-hidden');
    }, { threshold: 0 });
    document.querySelectorAll('[data-clc-hide-sticky]').forEach(function(t){ io.observe(t); });
  }

  /* ---------- quiz ---------- */
  var dataEl = document.querySelector('[data-clc-quiz-data]');
  var root = document.querySelector('[data-clc-quiz-root]');
  if(!dataEl || !root) return;
  var DATA; try { DATA = JSON.parse(dataEl.textContent); } catch(e){ return; }
  var C = DATA.copy, TOTAL = DATA.total || DATA.questions.length;
  var LETTERS = ['a','b','c','d'];
  var STORE_KEY = 'clc_er_quiz_v1';

  var state = { step:0, answers:{}, name:'', email:'', emailErr:false };
  var overlay = null, advT = null;

  function load(){ try { return JSON.parse(localStorage.getItem(STORE_KEY)||'null'); } catch(e){ return null; } }
  function deadline(){ var el=document.querySelector('[data-clc-deadline]'); if(!el) return NaN; var v=(el.getAttribute('data-clc-deadline')||'').trim(); return v?new Date(v.replace(' ','T')).getTime():NaN; }
  function active(){ var d=deadline(); return !isNaN(d) && (d-Date.now()>0); }
  function computeProfile(){ var c={a:0,b:0,c:0,d:0}; for(var i=0;i<6;i++){ var l=state.answers[i]; if(c[l]!==undefined)c[l]++; } var best='a',mx=-1; LETTERS.forEach(function(l){ if(c[l]>mx){mx=c[l];best=l;} }); return best; }
  function tokf(str){ return (str||'').replace('{n}', Math.min(state.step,TOTAL-1)+1).replace('{total}', TOTAL); }

  function open(){
    var saved = load();
    if(saved && saved.completedTs && saved.answers){
      state.answers = {}; for(var k=0;k<TOTAL;k++){ var v=saved.answers['q'+(k+1)]; if(v) state.answers[k]=v; }
      state.name = saved.firstName||''; state.email = saved.email||''; state.step = 8;
    } else { state.step = 0; }
    state.emailErr = false;
    render();
    document.addEventListener('keydown', onKey);
  }
  function close(){ if(overlay){ overlay.remove(); overlay=null; } document.removeEventListener('keydown', onKey); if(advT){clearTimeout(advT);advT=null;} }
  function onKey(e){ if(e.key==='Escape') close(); }

  function el(tag, cls, txt){ var n=document.createElement(tag); if(cls)n.className=cls; if(txt!=null)n.textContent=txt; return n; }
  function offerSpans(activeNode, expiredNode){ activeNode.setAttribute('data-clc-offer','active'); expiredNode.setAttribute('data-clc-offer','expired'); var a=active(); activeNode.hidden=!a; expiredNode.hidden=a; }

  function render(){
    if(!overlay){
      overlay = el('div','clc-qz-overlay'); overlay.setAttribute('data-clc-quiz-overlay','');
      overlay.addEventListener('click', function(e){ if(e.target===overlay) close(); });
      root.appendChild(overlay);
    }
    overlay.innerHTML='';
    var card = el('div','clc-qz-card'); overlay.appendChild(card);
    var closeBtn = el('button','clc-qz-close','✕'); closeBtn.setAttribute('aria-label', C.closeLabel||'Close'); closeBtn.addEventListener('click', close); card.appendChild(closeBtn);

    if(state.step<=6) renderQuestion(card);
    else if(state.step===7) renderEmail(card);
    else renderResult(card);

    var foot = el('span','clc-qz-foot', C.disclaimer); card.appendChild(foot);
    syncOffer();
  }

  function renderQuestion(card){
    var qi = Math.min(state.step,TOTAL-1), q = DATA.questions[qi];
    var head = el('div','clc-qz-col');
    head.appendChild(el('span','clc-qz-kick', tokf(C.progress)));
    var bar = el('div','clc-qz-bar'); var fill = el('div','clc-qz-bar-fill'); fill.style.width = Math.round(((qi+1)/TOTAL)*100)+'%'; bar.appendChild(fill); head.appendChild(bar);
    card.appendChild(head);
    card.appendChild(el('h3','clc-qz-q', q.q));
    var opts = el('div','clc-qz-opts');
    q.opts.forEach(function(label,i){
      if(label==null||label==='') return;
      var b = el('button','clc-qz-opt',label);
      if(state.answers[qi]===LETTERS[i]) b.setAttribute('data-picked','');
      b.addEventListener('click', function(){
        state.answers[state.step]=LETTERS[i];
        if(advT) clearTimeout(advT);
        var atStep = state.step;
        render();
        advT = setTimeout(function(){ if(overlay && state.step===atStep){ state.step=atStep+1; render(); } }, 220);
      });
      opts.appendChild(b);
    });
    card.appendChild(opts);
    var nav = el('div','clc-qz-nav');
    if(state.step>0){ var back=el('button','clc-qz-link',C.back); back.addEventListener('click',function(){ state.step=Math.max(0,state.step-1); render(); }); nav.appendChild(back); }
    else nav.appendChild(el('span'));
    if(state.step<=6 && state.answers[qi]){ var next=el('button','clc-qz-link clc-qz-link--next',C.next); next.addEventListener('click',function(){ state.step=Math.min(7,state.step+1); render(); }); nav.appendChild(next); }
    else nav.appendChild(el('span'));
    card.appendChild(nav);
  }

  function renderEmail(card){
    card.appendChild(el('h3','clc-qz-h3', C.emailHeading));
    var col = el('div','clc-qz-col');
    var name = el('input','clc-qz-field'); name.type='text'; name.placeholder=C.namePh; name.value=state.name; name.addEventListener('input',function(){ state.name=name.value; });
    var email = el('input','clc-qz-field'); email.type='email'; email.placeholder=C.emailPh; email.value=state.email; email.addEventListener('input',function(){ state.email=email.value; });
    col.appendChild(name); col.appendChild(email);
    if(state.emailErr) col.appendChild(el('span','clc-qz-err', C.emailErr));
    var submit = el('button','clc-qz-btn', C.submit);
    submit.addEventListener('click', function(){
      var em=(state.email||'').trim();
      if(em.indexOf('@')<1 || em.indexOf('.')<0){ state.emailErr=true; render(); return; }
      var ans={}; for(var k=0;k<TOTAL;k++){ ans['q'+(k+1)]=state.answers[k]||null; }
      var key=computeProfile();
      var rec={ firstName:(state.name||'').trim(), email:em, profileKey:key, profile:(DATA.profiles[key]||{}).name, answers:ans, completedTs:Date.now() };
      try { localStorage.setItem(STORE_KEY, JSON.stringify(rec)); } catch(e){}
      try { document.dispatchEvent(new CustomEvent('clc-er:quiz-complete', { detail: rec })); } catch(e){}
      state.step=8; state.emailErr=false; render();
    });
    col.appendChild(submit);
    col.appendChild(el('span','clc-qz-note', C.emailNote));
    card.appendChild(col);
    var nav=el('div'); var back=el('button','clc-qz-link',C.back); back.addEventListener('click',function(){ state.step=7-1; state.step=6; render(); }); nav.appendChild(back); card.appendChild(nav);
  }

  function renderResult(card){
    var key=computeProfile(), prof=DATA.profiles[key]||{name:'',body:''};
    var q7=state.answers[6], soft=(q7==='b'||q7==='d');
    var col=el('div','clc-qz-col');
    col.appendChild(el('span','clc-qz-kick', C.resultKicker));
    col.appendChild(el('h3','clc-qz-h3', prof.name));
    col.appendChild(el('p','clc-qz-result-body', prof.body));
    col.appendChild(el('p','clc-qz-result-tag', C.tagline));
    var div=el('div','clc-qz-divide');
    var pa=el('span','clc-qz-priceline'); pa.innerHTML = escapeHtml(C.activePre)+' <strong>'+escapeHtml(C.founding)+'</strong> · <span class="clc-cd" data-clc-countdown>--:--:--</span>';
    var pe=el('span','clc-qz-priceline'); pe.innerHTML = escapeHtml(C.expired)+' <strong>'+escapeHtml(C.regular)+'</strong>';
    offerSpans(pa,pe); div.appendChild(pa); div.appendChild(pe);
    var cta=el('a','clc-qz-btn'); cta.href=C.ctaUrl; cta.innerHTML=escapeHtml(C.cta)+' · <span data-clc-offer="active">'+escapeHtml(C.founding)+'</span><span data-clc-offer="expired" hidden>'+escapeHtml(C.regular)+'</span>';
    div.appendChild(cta);
    if(!soft){ div.appendChild(el('span','clc-qz-note clc-qz-center', C.readyNote)); }
    else {
      var hold=el('span','clc-qz-note clc-qz-center'); hold.innerHTML = escapeHtml(C.softHold)+' <span class="clc-cd" data-clc-countdown>--:--:--</span>.';
      div.appendChild(hold);
      var link=el('button','clc-qz-link clc-qz-center'); link.style.alignSelf='center'; link.textContent=C.softLink;
      link.addEventListener('click', function(){ close(); if(C.storyAnchor) window.location.hash=C.storyAnchor; });
      div.appendChild(link);
    }
    col.appendChild(div); card.appendChild(col);
  }

  function escapeHtml(str){ return (str||'').replace(/[&<>"']/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function syncOffer(){ var a=active(); overlay && overlay.querySelectorAll('[data-clc-offer="active"]').forEach(function(e){e.hidden=!a;}); overlay && overlay.querySelectorAll('[data-clc-offer="expired"]').forEach(function(e){e.hidden=a;}); }

  document.addEventListener('click', function(e){ var t=e.target.closest && e.target.closest('.clc-quiz-open'); if(t){ e.preventDefault(); open(); } });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clc-er-testimonials"] && !Shopify.designMode) return;
  try {
    
(function(){
  function bind(scope){
    (scope||document).querySelectorAll('.clc-tst-play').forEach(function(btn){
      if(btn.__clcBound) return; btn.__clcBound = true;
      btn.addEventListener('click', function(){
        var vid = btn.parentNode.querySelector('.clc-tst-video');
        if(!vid) return;
        btn.style.display='none';
        vid.setAttribute('controls','');
        var p = vid.play(); if(p && p.catch) p.catch(function(){});
      });
    });
  }
  bind(); document.addEventListener('shopify:section:load', function(e){ bind(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clc-er-transformation"] && !Shopify.designMode) return;
  try {
    
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window) || reduce) return;
  var io = new IntersectionObserver(function(ents){
    ents.forEach(function(e){
      if(!e.isIntersecting) return; io.unobserve(e.target);
      var el = e.target, target = parseInt(el.getAttribute('data-clc-count'),10);
      if(isNaN(target)){ return; }
      var dur = Math.min(1600, 350 + target*130), t0 = null;
      function step(ts){ if(!t0) t0=ts; var p=Math.min(1,(ts-t0)/dur);
        el.textContent = String(Math.max(1, Math.round(target*(1-Math.pow(1-p,2)))));
        if(p<1) requestAnimationFrame(step); else el.textContent=String(target); }
      requestAnimationFrame(step);
    });
  }, { threshold: 0.6 });
  function scan(){ document.querySelectorAll('.clc-tr-num [data-clc-count]').forEach(function(el){ io.observe(el); }); }
  scan(); document.addEventListener('shopify:section:load', scan);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.__clcErInit) return; window.__clcErInit = true;
  var root = document.documentElement;

  // ---- scroll-reveal (opt-in, motion-safe) ----
  var motionOK = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (motionOK && 'IntersectionObserver' in window){
    root.classList.add('clc-anim-ready');
    var rio = new IntersectionObserver(function(ents){
      ents.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); rio.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    var scan = function(){ document.querySelectorAll('[data-clc-reveal]:not(.is-in)').forEach(function(el){ rio.observe(el); }); };
    scan(); document.addEventListener('shopify:section:load', scan);
  }

  // ---- header on scroll ----
  var header = document.querySelector('[data-clc-header]');
  var onScroll = function(){ if(!header) return; if(window.scrollY > 24) header.setAttribute('data-clc-scrolled',''); else header.removeAttribute('data-clc-scrolled'); };
  window.addEventListener('scroll', onScroll, { passive:true }); onScroll();

  // ---- mobile menu ----
  var burger = document.querySelector('[data-clc-burger]');
  var menu = document.querySelector('[data-clc-mobile-menu]');
  if (burger && menu){
    burger.addEventListener('click', function(){
      var open = menu.hasAttribute('hidden');
      if(open){ menu.removeAttribute('hidden'); burger.setAttribute('aria-expanded','true'); }
      else { menu.setAttribute('hidden',''); burger.setAttribute('aria-expanded','false'); }
    });
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ menu.setAttribute('hidden',''); burger.setAttribute('aria-expanded','false'); }); });
  }
})();

  } catch(e) { console.error(e); }
})();
})();
